<ion-grid class="duration-picker">
  <div *ngIf="renderType === 'MODAL'" (click)="dismissModal()" class="duration-picker__close-btn"></div>
  <ion-row>
    <ion-col size="24" class="duration-picker__title">
      <div>{{ 'duration_picker.SelectDate' | translate }}</div>
    </ion-col>
  </ion-row>
  <ion-row>
    <ion-col *ngIf="customLabelText" class="duration-picker__label" size="24">
      <div>{{ customLabelText | translate }}</div>
    </ion-col>
  </ion-row>
  <ng-container *ngFor="let option of optionList">
    <ion-row
      class="duration-picker__date-row"
      [ngClass]="{
        'duration-picker__date-row--selected': currentSelectedDate?.type === option.id,
        'duration-picker__date-row--custom': option?.id === 'CUSTOM'
      }"
      (click)="changeSelected(option.id)"
    >
      <ion-col size="4">
        <div
          class="duration-picker__icons"
          [ngClass]="currentSelectedDate?.type === option.id ? option.activeIcon : option.icon"
        ></div>
      </ion-col>
      <ion-col size="18">
        <div class="duration-picker__date-title">{{ option.title | translate }}</div>
        <div class="duration-picker__date">{{ option.subtxt }}</div>
      </ion-col>
      <ion-col size="2" *ngIf="currentSelectedDate?.type === option.id">
        <div class="duration-picker__selected-icon"></div>
      </ion-col>
    </ion-row>
  </ng-container>
  <ion-grid>
    <ion-row class="duration-picker__align-center duration-picker__justify-center">
      <ion-col size="11">
        <div class="duration-picker__custom-date-item">
          <ion-input type="date" [(ngModel)]="customFromDate" (ionChange)="onCustomDatesChange()"></ion-input>
        </div>
      </ion-col>
      <ion-col size="2">
        <div class="duration-picker__txt-center">-</div>
      </ion-col>
      <ion-col size="11">
        <div class="duration-picker__custom-date-item">
          <span>
            <ion-input type="date" [(ngModel)]="customToDate" (ionChange)="onCustomDatesChange()"></ion-input>
          </span>
        </div>
      </ion-col>
      <ion-col size="24" *ngIf="showCustomDateError">
        <div class="duration-picker__custom-date-error">
          {{ 'duration_picker.ErrorText' | translate }}
        </div>
      </ion-col>
    </ion-row>
  </ion-grid>
  <ion-row *ngIf="renderType === 'MODAL'" class="duration-picker__btn-row">
    <ion-col size="12" class="duration-picker__cancel-btn">
      <ui-custom-button
        [buttonType]="'SECONDARY'"
        [btnTxt]="'duration_picker.Clear' | translate"
        [expand]="'block'"
        (clickEvent)="clearFilter()"
      ></ui-custom-button>
    </ion-col>
    <ion-col size="12" class="duration-picker__apply-btn">
      <ui-custom-button
        [buttonType]="'PRIMARY'"
        [btnTxt]="'duration_picker.Apply' | translate"
        [expand]="'block'"
        (clickEvent)="applyFilter()"
      ></ui-custom-button
    ></ion-col>
  </ion-row>
</ion-grid>
